export default __webpack_public_path__ + "static/media/umbra.2e8b4cfe.png";